export const latestProjects = [
    {
        index: 0,
        imgUrl:
            'https://img.freepik.com/free-vector/application-learn-languages_23-2148624202.jpg?w=826&t=st=1706246241~exp=1706246841~hmac=7a150592f1bc3d4576b51948e96bf36baeeb60f4d1907294f5e093b126c4437f',
        projectName: 'EduMetrics Pro',
        projectDomain: 'Flutter App',
        dataOfCompletion: '31/1/2024',
        projectShortDescription: 'A classroom manager mobile application',
    },
    {
        index: 1,
        imgUrl:
            'https://img.freepik.com/free-psd/digital-marketing-landing-page-template_23-2148924857.jpg?w=900&t=st=1706260411~exp=1706261011~hmac=72038f30c44349b0f8a2dad71ac81b82647e7f080e70a3a63c6cd785f2fdcefb',
        projectName: 'Project Hub',
        projectDomain: 'Web App',
        dataOfCompletion: '5/2/2024',
        projectShortDescription: 'A website to support student and developers',
    },
    {
        index: 2,
        imgUrl:
            'https://img.freepik.com/free-vector/space-explorer-landing-page-template_107791-16255.jpg?w=740&t=st=1706260494~exp=1706261094~hmac=6514cf89f1193473d4e88c72012d3acbe65df967b9d146b53463676b583f2a4e',
        projectName: 'Space Shooter',
        projectDomain: 'Game Application',
        dataOfCompletion: '12/12/2022',
        projectShortDescription: 'A game in which the user destroys enemy ships',
    },
];

export const skills = [
    {
        index: 0,
        title: "React",
        iconSrc: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg",
        description: "As a certified React developer, I've embarked on numerous projects harnessing the power of React. Through this journey, I've honed my skills and expertise, delivering a multitude of successful projects."
    },
    {
        index: 1,
        title: "Unity",
        iconSrc: "https://camo.githubusercontent.com/5f675d7f25e0b706790a667aea70e6ca54c8ddb55fdbed851ab95884e51c7c9f/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f756e69747933642f756e69747933642d69636f6e2e737667",
        description: "Becoming a certified Unity expert, I've delved into the intricacies of the Unity game development engine, mastering its tools and techniques. Along this journey, I've crafted a diverse array of games."
    },
    {
        index: 2,
        title: "Flutter",
        iconSrc: "https://www.vectorlogo.zone/logos/flutterio/flutterio-icon.svg",
        description: "An adept Flutter enthusiast, I've delved deep into the core of Flutter, mastering its intricacies to craft two impactful mobile applications. Through this journey, I've acquired a wealth of experience and expertise."
    },
    {
        index: 3,
        title: "Django",
        iconSrc: "https://camo.githubusercontent.com/c96cb99431280ee1fdce3fe6b5338c5aca7bcaf94331b7426803ac9b426f6cef/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f646a616e676f2e737667",
        description: "As a seasoned Django developer, I've leveraged its robust framework to create numerous comprehensive backend applications. With a keen eye for detail and a passion for elegant solutions, I've honed my skills to deliver high-quality projects that meet the needs of clients and users alike."
    },

]